const kiaf = {
  state: {
    keepAliveIncludeList: [],
    keepAliveExcludeList: [],
    sidebar: {
      opened: true,
      withoutAnimation: false
    },
    activedTagId: '',
    menuData: [],
    menuActiveIndex: '',
    menuVActiveIndex: '',
    breadCrumbList: [],
    webview: {
      id: 0,
      url: '',
      sign: '',
      external: false,
      internal: false
    },
    tagList: [], //顶部标签页,
    personCenter: {
      downloadState: false
    }
  },
  mutations: {
    KIAF_SHOW_PERSON_CENTER_DOWNLOAD: (state) => {
      state.personCenter.downloadState = true;
    },
    KIAF_HIDE_PERSON_CENTER_DOWNLOAD: (state) => {
      state.personCenter.downloadState = false;
    },
    KIAF_KEEP_ALIVE_SET_INCLUDE: (state, items) => {
      state.keepAliveIncludeList = items;
    },
    KIAF_KEEP_ALIVE_PUSH_INCLUDE: (state, item) => {
      state.keepAliveIncludeList.push(item);
    },
    KIAF_KEEP_ALIVE_SET_EXCLUDE: (state, items) => {
      state.keepAliveExcludeList = items;
    },
    KIAF_KEEP_ALIVE_PUSH_EXCLUDE: (state, item) => {
      state.keepAliveExcludeList.push(item);
    },
    KIAF_INIT_VUEX: state => {
      state.webview.id = 0;
      state.webview.url = '';
      state.webview.sign = '';
      state.webview.external = false;
      state.webview.internal = false;

      state.tagList = [];
      state.breadCrumbList = [];
      state.menuData = [];
      state.menuActiveIndex = '';
      state.menuVActiveIndex = '';

      state.sidebar.opened = true;
      state.sidebar.withoutAnimation = false;
    },
    KIAF_TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    },
    KIAF_CLOSE_SIDEBAR: (state, withoutAnimation) => {
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    KIAF_TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    KIAF_SET_MENUDATA: (state, menuData) => {
      state.menuData = menuData;
    },
    KIAF_SET_BREADCRUMB: (state, menuData) => {
      state.breadCrumbList = menuData;
    },
    KIAF_SET_TAGLIST: (state, tagList) => {
      state.tagList = tagList;
    },
    KIAF_SET_MENUACTIVEINDEX: (state, menuActiveIndex) => {
      state.menuActiveIndex = menuActiveIndex;
    },
    KIAF_SET_V_MENUACTIVEINDEX: (state, menuVActiveIndex) => {
      state.menuVActiveIndex = menuVActiveIndex;
    },
    KIAF_SET_WEBVIEW: (state, params) => {
      for(let key in params){
        state.webview[key] = params[key];
      }
    },
    KIAF_SET_ACTIVED_TAG_ID: (state, tagId) => {
      state.activedTagId = tagId;
    },
    KIAF_INIT_WEBVIEW: (state, params) => {
      state.webview.id = 0;
      state.webview.url = '';
      state.webview.sign = '';
      state.webview.external = false;
      state.webview.internal = false;
    }
  },
  actions: {
    kiafToggleSideBar({commit}) {
      commit('KIAF_TOGGLE_SIDEBAR');
    },
    kiafCloseSideBar({commit}, {withoutAnimation}) {
      commit('KIAF_CLOSE_SIDEBAR', withoutAnimation);
    },
    kiafToggleDevice({commit}, device) {
      commit('KIAF_TOGGLE_DEVICE', device);
    }
  }
};

export default kiaf;
